import {Text, View, FontSizeProp, Box} from "@unibuddy/patron";
import {CountryFlag} from "ubcommunity-shared/src/General/CountryFlag";
import {CountryField, FlagField} from "ubcommunity-shared/src/types";

type CountryFlagWithNameProps = {
    country: CountryField | FlagField;
    flagSize: number;
    textSize?: FontSizeProp;
};
export const CountryFlagWithName = ({
    country,
    flagSize,
    textSize = "medium",
}: CountryFlagWithNameProps) => {
    return (
        <View flexDirection="row" alignItems="center" data-testid="country-flag" flex={1}>
            <CountryFlag
                size={flagSize}
                label={country.name ?? ""}
                code={country.code ?? ""}
                isRound={false}
            />
            <Box flex={1}>
                <Text size={textSize}>{country.name}</Text>
            </Box>
        </View>
    );
};
